<template>
    <v-card class="mt-3 py-6 px-0 trans-bkg" flat>
        <v-form ref="form">
            <v-text-field
                :rules="[value => !!value || 'Required.']"
                label="Label"
                required
                v-model="item.label"
            />
        </v-form>
        <v-card-actions class="justify-end">
            <v-btn 
                color="primary lighten-2 info--text"
                @click="handleSave">
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment';

    export default {
        name: 'ProjectStepDetails',

        props: {
            item: {
                type: Object,
                required: true,
                default: {}
            }
        },
    
        methods: {
            handleSave: async function () {
                if (this.$refs.form.validate()) {
                    await this.saveStepData();
                    this.$emit('close');
                    this.$emit('save', this.item);
                }
            },

            async saveStepData () {
                const { 
                    order_number,
                    label,
                    name,
                    project_id,
                    projectstep_id
                } = this.item;

                const payload = {
                    order_number,
                    label,
                    name,
                    project_id,
                    projectstep_id
                };
                let stepSave;

                if (projectstep_id) {
                    stepSave = await axios.put(
                        `${appUrls.api}/api/admin/project_step/${projectstep_id}`,
                        payload,
                        {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                        }
                    );
                } else {
                    stepSave = await axios.post(
                        `${appUrls.api}/api/admin/project/${project_id}/project_step`,
                        payload,
                        {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                        }
                    );

                }
                
                return stepSave;
            }
        }
    }
</script>

<style scoped>
    .trans-bkg {
        background-color: transparent !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectReportStepDialog.vue